import { AccredibleMenuComponent } from '@accredible-frontend-v2/new-components/menu';
import { CdkMenu } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'accredible-table-kebab-button',
  templateUrl: './table-kebab-button.component.html',
  styleUrls: [`./table-kebab-button.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleTableKebabButtonComponent {
  /**
   * @deprecated menu input is deprecated, use cdkMenuTemplateRef instead
   * TODO(Fred): remove this input once all accredible-table-kebab-button are migrated to cdkMenuTemplateRef
   */
  menu = input<AccredibleMenuComponent>();

  cdkMenuTemplateRef = input<TemplateRef<CdkMenu>>();
  dataCy = input<string>();
}
